// @core/api/endpoints/tenant/list_tenant_members.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTenantMembersResponse,
} from '../../../types/tenant';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/tenant';

/**
 * List tenant members
 * Returns a paginated list of all members belonging to the tenant, including their roles and join dates. Requires membership in the tenant.
 */
export async function ListTenantMembers(
  tenant_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTenantMembersResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/members`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.get<ListTenantMembersResponse>(requestPath, { ...requestOptions, params });
}
